/* BD Callback v1.4, 2026-09-27. Confirmed callbacks complete B2 and consent-aware Klaviyo independently, with one attempt identity and isolated pending state. */
(function () {
  'use strict';
  if (window.bdCallbackForm) return;
  var neutral = 'Montag bis Freitag: bis 16:30 Uhr anfragen – Rückruf noch heute. Danach am nächsten Arbeitstag bis 10 Uhr. Feiertage ausgenommen.';
  function financeTopic(value) {
    var key = String(value || '').toLowerCase();
    return key === 'mietkauf' ? 'Mietkauf' : key === 'leasing' ? 'Leasing' : key === 'finanzierung' ? 'Finanzierung' : '';
  }
  function timing() {
    try {
      if (window.bdCallbackTime && typeof window.bdCallbackTime.describe === 'function') {
        return window.bdCallbackTime.describe(new Date()) || {};
      }
    } catch (error) {}
    return {};
  }
  function refresh(card) {
    if (card.dataset.bdCallbackResponse === 'confirmed') return;
    var info = timing();
    var title = card.querySelector('[data-bd-callback-title]');
    var text = card.querySelector('[data-bd-callback-text]');
    if (title) title.textContent = info.title || 'Wir rufen Sie persönlich zurück.';
    if (text) text.textContent = info.promise || neutral;
  }
  function removePending(formId) {
    var pending = readState('bd47_pending');
    // Another product or callback form may still be awaiting its own confirmation.
    if (pending && pending.callback_form_id === formId) removeState('bd47_pending');
  }
  var pendingKey = 'bd_callback_pending';
  var receiptKey = 'bd_callback_receipt';
  function readState(key) {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (error) { return null; }
  }
  function saveState(key, state) {
    try { window.sessionStorage.setItem(key, JSON.stringify(state)); } catch (error) {}
  }
  function removeState(key) { try { window.sessionStorage.removeItem(key); } catch (error) {} }
  function fresh(state, field, ttl) {
    var age = state && Date.now() - state[field];
    return !!(state && typeof state[field] === 'number' && isFinite(age) && age >= 0 && age <= ttl);
  }
  function token() {
    try { var bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes); return Array.from(bytes, function (n) { return n.toString(16).padStart(2, '0'); }).join(''); }
    catch (error) { return Date.now().toString(36) + Math.random().toString(36).slice(2); }
  }
  function returnMatches(own, form, address) {
    if (!fresh(own, 'created_at', 86400000) || own.form_id !== form.id || !own.attempt_id || !own.path) return false;
    try {
      var url = new URL(address, location.href);
      return url.origin === location.origin && url.pathname === own.path && url.hash === '#' + encodeURIComponent(form.id) &&
        url.searchParams.get('contact_posted') === 'true' && url.searchParams.get('bd_callback_attempt') === own.attempt_id;
    } catch (error) { return false; }
  }
  function receiptMatches(receipt, form) {
    if (!fresh(receipt, 'confirmed_at', 900000) || receipt.form_id !== form.id || receipt.path !== location.pathname) return false;
    if (location.hash && location.hash !== '#' + encodeURIComponent(form.id)) return false;
    var params = new URLSearchParams(location.search);
    if (params.has('bd_callback_attempt') && params.get('bd_callback_attempt') !== receipt.attempt_id) return false;
    if (/\/pages\/rueckruf\/?$/.test(location.pathname)) {
      if ((params.get('produkt') || '') !== (receipt.product_handle || '')) return false;
      if (financeTopic(params.get('anliegen')) !== (receipt.topic || '')) return false;
    }
    return true;
  }
  function cleanReturn() {
    try {
      var url = new URL(location.href);
      url.searchParams.delete('contact_posted'); url.searchParams.delete('bd_callback_attempt');
      history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch (error) {}
  }
  function showSuccess(form, card, own, focus) {
    var marker = form.querySelector('[data-bd-callback-confirmed]');
    if (!marker) return false;
    var fields = form.querySelector('[data-bd-callback-fields]');
    var error = form.querySelector('[data-bd-callback-server-error]');
    if (fields) fields.hidden = true;
    if (error) error.hidden = true;
    marker.hidden = false;
    card.dataset.bdCallbackResponse = 'confirmed';
    var title = own && own.name ? 'Danke, ' + own.name + '.' : 'Ihr Rückruf ist angefordert.';
    var message = own && typeof own.success_text === 'string' && own.success_text.length < 180 ? own.success_text : 'Ihre Anfrage wurde übermittelt. Wir melden uns persönlich bei Ihnen.';
    if (own && own.phone) message = message.replace(/ zurück\.$/, ' unter ' + own.phone + ' an.');
    var heading = card.querySelector('[data-bd-callback-title]');
    var promise = card.querySelector('[data-bd-callback-text]');
    if (heading) heading.textContent = title;
    if (promise) { promise.textContent = message; promise.hidden = true; }
    var strong = marker.querySelector('strong'); if (strong) strong.textContent = 'Ihre Rückrufanfrage wurde übermittelt.';
    var p = marker.querySelector('p'); if (p) p.textContent = message;
    if (own && /^[a-z0-9][a-z0-9-]{0,179}$/.test(own.product_handle || '')) {
      var back = document.querySelector('[data-bd-callback-back]');
      if (back) { back.href = '/products/' + encodeURIComponent(own.product_handle); back.textContent = 'Zurück zum Gerät ↗'; }
      var label = card.querySelector('[data-bd-callback-context]');
      if (label && own.product_title) { label.textContent = [own.topic, own.product_title].filter(Boolean).join(' · '); label.hidden = false; }
    }
    // The receipt restores UI only; it never repeats a conversion or a POST.
    var again = marker.querySelector('[data-bd-callback-again]');
    if (!again) {
      again = document.createElement('button'); again.type = 'button'; again.className = 'bd-callback__again';
      again.setAttribute('data-bd-callback-again', ''); again.textContent = 'Neue Rückrufanfrage'; marker.appendChild(again);
      again.addEventListener('click', function () {
        removeState(receiptKey); removeState(pendingKey); cleanReturn();
        if (/\/pages\/rueckruf\/?$/.test(location.pathname)) { location.reload(); return; }
        var url = new URL('/pages/rueckruf', location.origin);
        if (own && /^[a-z0-9][a-z0-9-]{0,179}$/.test(own.product_handle || '')) url.searchParams.set('produkt', own.product_handle);
        if (own && financeTopic(own.topic)) url.searchParams.set('anliegen', own.topic.toLowerCase());
        location.assign(url.href);
      });
    }
    card.dispatchEvent(new CustomEvent('bd:callback-confirmed', { bubbles: true, detail: { formId: form.id } }));
    if (focus) marker.focus({ preventScroll: true });
    return true;
  }
  function recordSuccess(form, card, own, liveForm) {
    if (card.dataset.bdCallbackResponse === 'confirmed') return;
    if (!showSuccess(form, card, own, true)) return;
    removeState(pendingKey);
    // Name and phone stay only in this tab for a short confirmation/reload window.
    // No email, attribution or tracking identity is copied into this UI receipt.
    saveState(receiptKey, { form_id: own.form_id, path: own.path, product_handle: own.product_handle, product_title: own.product_title,
      topic: own.topic, attempt_id: own.attempt_id, confirmed_at: Date.now(), name: own.name, phone: own.phone,
      success_text: own.success_text });
    if (liveForm) {
      try { history.replaceState({}, '', own.return_url); } catch (error) {}
    }
    cleanReturn();
    var ctx = own.tracking;
    if (!ctx || ['bd21_machine_lead', 'bd_callback_lead'].indexOf(ctx.form_id) === -1 || !ctx.event_id ||
        ctx.callback_form_id !== form.id || (ctx.product_handle || '') !== own.product_handle) return;
    removePending(form.id);
    var event = { event: 'beamdeals_machine_form_submit', form_id: 'bd21_machine_lead',
      source_form_id: ctx.form_id, event_id: ctx.event_id, bd_submission_id: ctx.event_id,
      form_name: ctx.product_handle ? 'Rückruf zum Gerät' : 'Rückruf', form_status: 'success', lead_type: 'callback',
      page_path: own.path, thema: ctx.thema, product_handle: ctx.product_handle || '' };
    var completed = false;
    try {
      if (window.bdSubmissionB2 && typeof window.bdSubmissionB2.complete === 'function') {
        completed = window.bdSubmissionB2.complete(event, liveForm || null, false) === true;
      }
    } catch (error) {}
    try {
      if (!completed && window.bdLeadTracking && typeof window.bdLeadTracking.complete === 'function') window.bdLeadTracking.complete(event);
    } catch (error) {}
    // Shopify confirmation is the evidence for both channels. A missing/failed B2
    // completion must not suppress Klaviyo; its helper applies consent and dedupe.
    try {
      if (window.bdLeadTracking && typeof window.bdLeadTracking.track === 'function') window.bdLeadTracking.track(ctx);
    } catch (error) {}
  }
  function completeNative(form, card) {
    var own = readState(pendingKey);
    var marker = form.querySelector('[data-bd-callback-confirmed]');
    var serverError = form.querySelector('[data-bd-callback-server-error]:not([hidden])');
    var ownTarget = location.hash === '#' + encodeURIComponent(form.id);
    // Shopify shares contact response flags with every contact form on a page.
    // Restore this form when the response belongs to another form's return target.
    if (!ownTarget) {
      if (marker) marker.hidden = true;
      if (serverError) { serverError.hidden = true; serverError = null; }
      var fields = form.querySelector('[data-bd-callback-fields]');
      if (fields) fields.hidden = false;
    }
    if (serverError) return false;
    if (marker && marker.getAttribute('data-bd-callback-confirmed') === form.id && !marker.hidden && returnMatches(own, form, location.href)) {
      recordSuccess(form, card, own, null); return true;
    }
    var receipt = readState(receiptKey);
    if (receiptMatches(receipt, form)) { showSuccess(form, card, receipt, false); cleanReturn(); return true; }
    if (receipt && !fresh(receipt, 'confirmed_at', 900000)) removeState(receiptKey);
    // A bare success URL may render Shopify's neutral confirmation, but cannot count a lead.
    if (marker && !marker.hidden && marker.getAttribute('data-bd-callback-confirmed') === form.id) {
      card.dataset.bdCallbackResponse = 'confirmed';
      var title = card.querySelector('[data-bd-callback-title]'); if (title) title.textContent = 'Ihre Anfrage wurde übermittelt.';
      var promise = card.querySelector('[data-bd-callback-text]'); if (promise) promise.textContent = neutral;
      return true;
    }
    return false;
  }
  function init(root) {
    var cards = [];
    if (root && root.matches && root.matches('[data-bd-callback-form]')) cards.push(root);
    (root || document).querySelectorAll('[data-bd-callback-form]').forEach(function (card) { cards.push(card); });
    cards.forEach(function (card) {
      var form = card.querySelector('form[data-bd-callback-contact]');
      if (!form || form.dataset.bdCallbackReady) return;
      form.dataset.bdCallbackReady = 'true';
      refresh(card);
      if (completeNative(form, card)) return;
      var button = form.querySelector('[data-bd-callback-submit]');
      if (!button) return;
      var status = form.querySelector('[data-bd-callback-status]');
      var body = form.querySelector('[data-bd-callback-body]');
      var deadline = form.querySelector('[data-bd-callback-deadline]');
      var preview = form.dataset.bdCallbackPreview === 'true';
      var busy = false;
      var releaseTimer;
      var attempt = null;
      var attemptSignature = "";
      var ajaxInFlight = false;
      var contextTopic = '';
      var generatedBody = body.defaultValue || 'Rückruf gewünscht';
      function knownProduct() { return card.dataset.productKnown === 'true' && /^[a-z0-9][a-z0-9-]{0,179}$/.test(card.dataset.productHandle || ''); }
      function fieldValue(name) { var field = form.elements.namedItem(name); return field ? field.value : ''; }
      function setField(name, value) {
        var field = form.elements.namedItem(name);
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.appendChild(field); }
        field.value = value; field.defaultValue = value;
      }

      function syncBody() {
        var topic = form.querySelector('[name="contact[Rückrufthema]"]:checked');
        var topicText = topic ? topic.value : contextTopic;
        var productTitle = knownProduct() ? fieldValue('contact[Produkt]') : '';
        var summary = 'Rückruf gewünscht' + (topicText ? ' – ' + topicText : '') + (productTitle ? ' für ' + productTitle : '');
        // Preserve any additional message supplied by the customer or configurator.
        var message = body.value;
        if (message === generatedBody || message === 'Rückruf gewünscht') message = '';
        else if (message.indexOf(generatedBody + '\n\n') === 0) message = message.slice(generatedBody.length + 2);
        body.value = summary + (message ? '\n\n' + message : '');
        generatedBody = summary;
        setField('contact[Anliegen]', 'Rückruf' + (topicText ? ' – ' + topicText : ''));
        var contextLabel = card.querySelector('[data-bd-callback-context]');
        if (contextLabel) { contextLabel.textContent = [topicText, productTitle].filter(Boolean).join(' · '); contextLabel.hidden = !contextLabel.textContent; }
      }
      function syncReturn() {
        if (preview || !/^\/(?!\/)/.test(window.location.pathname)) return;
        var params = new URLSearchParams();
        var current = new URLSearchParams(window.location.search);
        var view = current.get('view');
        if (view && /^(?:bd-callback|bd-local-[a-z0-9-]{1,64})$/.test(view)) params.set('view', view);
        var theme = window.Shopify && window.Shopify.theme;
        if (theme && /^(unpublished|development)$/i.test(String(theme.role)) && /^\d+$/.test(String(theme.id))) params.set('preview_theme_id', String(theme.id));
        // Product comes from the server-resolved card, never from the URL alone.
        if (knownProduct() && (/\/pages\/rueckruf\/?$/.test(window.location.pathname) || view === 'bd-callback')) params.set('produkt', card.dataset.productHandle);
        var selectedTopic = form.querySelector('[name="contact[Rückrufthema]"]:checked');
        var financing = financeTopic(selectedTopic ? selectedTopic.value : contextTopic);
        if (financing) params.set('anliegen', financing.toLowerCase());
        params.set('contact_posted', 'true');
        if (attempt) params.set('bd_callback_attempt', attempt.attempt_id);
        var variant = current.get('variant');
        if (/^\d+$/.test(variant || '')) params.set('variant', variant);
        var field = form.querySelector('[name="return_to"]');
        if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.appendChild(field); }
        field.value = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + '#' + encodeURIComponent(form.id);
      }
      function unlock() {
        busy = false;
        clearTimeout(releaseTimer);
        button.removeAttribute('aria-disabled');
        button.textContent = preview ? 'Rückruf simulieren' : 'Rückruf anfordern';
      }
      function prepareCallback() {
        removePending(form.id); // Only this callback waits for its own nonce check.
        var machine = knownProduct() && card.dataset.machineProduct === 'true';
        var previousId = attempt && attempt.tracking && attempt.tracking.event_id;
        var ctx = {
          pending_created_at: attempt.created_at,
          form_id: machine ? 'bd21_machine_lead' : 'bd_callback_lead',
          callback_form_id: form.id,
          product_handle: knownProduct() ? card.dataset.productHandle : '',
          thema: machine ? 'machine' : 'callback',
          page_path: attempt.path,
          rueckruf_bis: attempt.deadline_iso || ''
        };
        // Native CAPTCHA replays belong to the original attempt, including when
        // B2 becomes available between submissions or has lost its own storage.
        if (previousId) { ctx.event_id = previousId; form.__bd2id = previousId; }
        try {
          if (window.bdSubmissionB2 && typeof window.bdSubmissionB2.prepare === 'function') {
            ctx = window.bdSubmissionB2.prepare(form, ctx) || ctx;
          }
        } catch (error) {}
        ctx.event_id = previousId || ctx.event_id || 'bd-callback-' + attempt.attempt_id;
        // B2.prepare normally enriches this context; this also covers missing or
        // interrupted B2. The shared helper alone decides identity/consent rules.
        try {
          if (window.bdLeadTracking && typeof window.bdLeadTracking.enrich === 'function') {
            ctx = window.bdLeadTracking.enrich(form, ctx) || ctx;
          }
        } catch (error) {}
        setField('contact[Einsendungs-ID]', ctx.event_id);
        return ctx;
      }
      card.bdCallbackSetContext = function (context) {
        if (busy || card.dataset.bdCallbackResponse === 'confirmed') return false;
        if (Object.prototype.hasOwnProperty.call(context, 'product')) {
          var product = context.product;
          if (product && (!product.known || !/^[a-z0-9][a-z0-9-]{0,179}$/.test(product.handle || '') || !product.title)) return false;
          var previous = card.dataset.productHandle || '';
          var handle = product ? product.handle : '';
          if (previous !== handle) {
            ['contact[Variante]', 'contact[Varianten-ID]', 'contact[Artikelnummer]', 'contact[konfiguration]'].forEach(function (name) {
              var field = form.elements.namedItem(name); if (field) field.remove();
            });
          }
          card.dataset.productKnown = product ? 'true' : 'false';
          card.dataset.machineProduct = product && product.machine ? 'true' : 'false';
          card.dataset.productHandle = handle;
          card.dataset.productTitle = product ? product.title : '';
          var machine = product && product.machine;
          // Callback requests opt in to B2 under their real form ID; regional forms remain excluded.
          form.dataset.bdLocalContact = 'false';
          setField('form_id', machine ? 'bd21_machine_lead' : 'bd_callback_lead');
          setField('contact[Formular-ID]', machine ? 'bd21_machine_lead' : 'bd_callback_lead');
          setField('contact[Lead-Typ]', machine ? 'machine' : 'callback');
          setField('contact[Produkt]', product ? product.title : '');
          setField('contact[Produkt-Handle]', handle);
          setField('contact[subject]', '[BeamDeals] Rückruf' + (product ? ' – ' + product.title : ''));
          if (product || previous !== handle) setField('contact[Technik]', product && product.technology || 'Noch offen');
        }
        if (Object.prototype.hasOwnProperty.call(context, 'topic')) {
          contextTopic = financeTopic(context.topic);
          form.querySelectorAll('[name="contact[Rückrufthema]"]').forEach(function (radio) {
            radio.checked = radio.value === contextTopic;
            radio.defaultChecked = radio.checked;
          });
        }
        syncBody(); syncReturn();
        return true;
      };
      form.addEventListener('change', function (event) {
        if (event.target.name === 'contact[Rückrufthema]') contextTopic = '';
        syncBody(); syncReturn();
      });
      form.addEventListener('invalid', function (event) {
        var details = event.target.closest('details');
        if (details) details.open = true;
      }, true);
      form.addEventListener('reset', function () {
        unlock();
        setTimeout(function () { syncBody(); deadline.value = ''; refresh(card); }, 0);
      });
      window.addEventListener('pageshow', function () { if (!ajaxInFlight && card.dataset.bdCallbackResponse !== 'confirmed') { unlock(); syncReturn(); refresh(card); } });
      button.addEventListener('click', function (event) { if (busy) event.preventDefault(); }, true);
      form.addEventListener('keydown', function (event) {
        if (busy && event.key === 'Enter' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
      }, true);
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        syncBody();
        syncReturn();
        if (preview) {
          event.preventDefault();
          if (busy) return;
          busy = true;
          button.setAttribute('aria-disabled', 'true');
          button.textContent = 'Vorschau geprüft';
          status.textContent = 'Vorschau: Es wurde kein Rückruf angefordert und keine Nachricht versendet.';
          return;
        }
        if (card.dataset.bdCallbackResponse === 'confirmed' || ajaxInFlight) { event.preventDefault(); return; }
        var selectedTopic = form.querySelector('[name="contact[Rückrufthema]"]:checked');
        var submittedTopic = financeTopic(selectedTopic ? selectedTopic.value : contextTopic);
        var signature = JSON.stringify([fieldValue('contact[Ansprechpartner]'), fieldValue('contact[Telefon]'),
          fieldValue('contact[email]'), card.dataset.productHandle || '', submittedTopic]);
        if (!attempt || (!busy && attemptSignature !== signature)) {
          // A new customer attempt gets a new identity. Replayed native CAPTCHA
          // submissions keep the existing attempt and never enter this branch.
          if (attemptSignature) { delete form.__bd2id; delete form.__bd2context; }
          var atSubmit = timing();
          var due = Date.parse(atSubmit.deadlineISO || '');
          deadline.value = isFinite(due) ? new Date(due).toISOString() : '';
          attempt = { form_id: form.id, path: location.pathname, created_at: Date.now(), attempt_id: token(),
            deadline_iso: deadline.value, success_text: atSubmit.successText || 'Wir melden uns persönlich bei Ihnen.',
            name: fieldValue('contact[Ansprechpartner]').trim().slice(0, 160), phone: fieldValue('contact[Telefon]').trim().slice(0, 50),
            product_handle: knownProduct() ? card.dataset.productHandle : '', product_title: knownProduct() ? fieldValue('contact[Produkt]').slice(0, 240) : '', topic: submittedTopic };
          attemptSignature = signature;
          removeState(receiptKey);
        }
        var prepared = prepareCallback();
        if (prepared) attempt.tracking = prepared;
        syncReturn();
        attempt.return_url = form.elements.namedItem('return_to').value;
        saveState(pendingKey, attempt);
        busy = true;
        button.setAttribute('aria-disabled', 'true');
        button.textContent = 'Anfrage wird übermittelt …';
        status.textContent = 'Bitte warten Sie auf die Bestätigung.';
        var systemType = form.elements.namedItem('form_type');
        var protectedForm = form.getAttribute('data-shopify-captcha') === 'true' ||
          form.hasAttribute('data-cptcha') || form.hasAttribute('data-hcaptcha-bound') ||
          form.hasAttribute('data-hcaptcha-protected') || form.hasAttribute('data-recaptcha-bound');
        // Shopify-owned CAPTCHA replay remains native. Never alter protected fields,
        // invoke hCaptcha directly or repeat a POST after an uncertain response.
        var ajaxReady = !event.defaultPrevented && !protectedForm && systemType && systemType.value === 'contact' &&
          window.fetch && window.FormData && window.DOMParser;
        if (!ajaxReady) {
          clearTimeout(releaseTimer);
          releaseTimer = setTimeout(function () { unlock(); status.textContent = 'Es liegt noch keine Bestätigung vor. Prüfen Sie eine mögliche Sicherheitsabfrage, bevor Sie erneut absenden.'; }, 45000);
          return;
        }
        event.preventDefault();
        // Shopify's unprotected contact-form persistence listener also calls submit().
        // Stop this AJAX-owned event from reaching that second native POST path.
        event.stopPropagation();
        ajaxInFlight = true;
        form.dataset.bdCallbackSending = 'true';
        var settled = false;
        var requestTimeout;
        var controller = window.AbortController ? new AbortController() : null;
        function failed(message) {
          if (settled) return;
          settled = true; clearTimeout(requestTimeout);
          attempt = null; // A customer-initiated retry snapshots the corrected fields.
          delete form.dataset.bdCallbackSending;
          ajaxInFlight = false; unlock();
          status.textContent = message;
          var errorBox = form.querySelector('[data-bd-callback-server-error]');
          if (errorBox) {
            errorBox.hidden = false;
            var detail = errorBox.querySelector('[data-bd-callback-error-text]'); if (detail) detail.textContent = message;
            errorBox.focus({ preventScroll: true });
          }
        }
        var errorBox = form.querySelector('[data-bd-callback-server-error]'); if (errorBox) errorBox.hidden = true;
        requestTimeout = setTimeout(function () {
          failed('Es liegt noch keine eindeutige Bestätigung vor. Bitte kontaktieren Sie uns telefonisch, bevor Sie die Anfrage erneut senden.');
          if (controller) controller.abort();
        }, 45000);
        var options = { method: 'POST', body: new FormData(form), redirect: 'follow', credentials: 'same-origin', headers: { 'Accept': 'text/html' } };
        if (controller) options.signal = controller.signal;
        fetch(form.action, options)
          .then(function (response) { return response.text().then(function (html) { return { ok: response.ok, url: response.url, html: html }; }); })
          .then(function (response) {
            if (settled) return;
            var target;
            try { target = new URL(response.url, location.href); } catch (error) {}
            if (!target || target.origin !== location.origin) { failed('Es liegt noch keine eindeutige Bestätigung vor. Bitte kontaktieren Sie uns telefonisch, bevor Sie die Anfrage erneut senden.'); return; }
            if (target.pathname === '/challenge') { settled = true; clearTimeout(requestTimeout); location.assign(target.href); return; }
            var result = new DOMParser().parseFromString(response.html, 'text/html');
            var returnedForm = result.getElementById(form.id);
            var success = returnedForm && returnedForm.querySelector('[data-bd-callback-confirmed]');
            var errors = returnedForm && returnedForm.querySelector('[data-bd-callback-server-error]:not([hidden])');
            // Fetch response URLs omit fragments. The known target hash comes from
            // this one request's validated return_to, never from a foreign response.
            var expected = new URL(attempt.return_url, location.origin);
            if (!target.hash) target.hash = expected.hash;
            if (response.ok && !errors && success && !success.hidden && success.getAttribute('data-bd-callback-confirmed') === form.id && returnMatches(attempt, form, target.href)) {
              settled = true; clearTimeout(requestTimeout);
              ajaxInFlight = false; clearTimeout(releaseTimer); recordSuccess(form, card, attempt, form); return;
            }
            if (errors) { failed('Ihre Anfrage wurde noch nicht bestätigt. Bitte prüfen Sie Ihre Angaben und versuchen Sie es erneut.'); return; }
            failed('Es liegt noch keine eindeutige Bestätigung vor. Bitte kontaktieren Sie uns telefonisch, bevor Sie die Anfrage erneut senden.');
          }).catch(function () { failed('Die Verbindung wurde unterbrochen. Bitte kontaktieren Sie uns telefonisch, bevor Sie die Anfrage erneut senden.'); });

      });
      syncBody();
      syncReturn();
      if (preview) { button.type = 'submit'; button.disabled = false; button.textContent = 'Rückruf simulieren'; }
    });
  }
  // Block duplicate AJAX submissions before document-level B2 preparation can
  // overwrite this in-flight request's identity. Native CAPTCHA replay is untouched.
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.matches && form.matches('form[data-bd-callback-contact]') && form.dataset.bdCallbackSending === 'true') {
      event.preventDefault(); event.stopPropagation();
    }
  }, true);
  window.bdCallbackForm = {
    init: init,
    financeTopic: financeTopic,
    setContext: function (card, context) { init(card); return !!(card && card.bdCallbackSetContext && card.bdCallbackSetContext(context || {})); },
    refresh: function () { document.querySelectorAll('[data-bd-callback-form]').forEach(refresh); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) window.bdCallbackForm.refresh(); });
  setInterval(function () { if (!document.hidden) window.bdCallbackForm.refresh(); }, 60000);
})();
